module.exports = __webpack_public_path__ + "img/xuexili-qrcode.f0c6a734.png";